import { hooks, mui, React, ts, ui } from '_core';

import { DraftParams } from './types';

type FormProps = {
  params: DraftParams;
  setParams: (_p: DraftParams) => void;
  context?: ts.types.signal.SignalAnalysisContext;
};

const Form = ({ params, setParams, context }: FormProps) => {
  const isAlpha = !!context?.alpha_type;

  const [returnHorizons, setReturnHorizons] = React.useState<ts.types.returnHorizon.ReturnHorizon[]>(
    params?.return_horizons || []
  );
  const [benchmark, setBenchmark] = React.useState(params.benchmark || null);
  const [withBenchmark, setWithBenchmark] = React.useState(params.with_benchmark || false);
  const [selectedHistories, setSelectedHistories] = React.useState(params.histories || []);
  const [showResidualsAlpha, setShowResidualsAlpha] = React.useState(params.show_residual_alpha || false);

  const uiStyles = hooks.useUiStyles();

  React.useEffect(() => {
    const data = {
      ...params,
      return_horizons: returnHorizons,
      histories: selectedHistories,
      with_benchmark: withBenchmark,
      show_residual_alpha: showResidualsAlpha,
    };

    if (withBenchmark) data.benchmark = benchmark;
    else if (data.benchmark) delete data.benchmark;

    setParams({ statistics_type: params.statistics_type, ...data });
  }, [returnHorizons, withBenchmark, selectedHistories, benchmark, showResidualsAlpha]);

  return (
    <mui.core.Box sx={uiStyles.widgetEditMode}>
      <mui.core.Box mt={4}>
        <ui.WidgetReturnHorizon<true>
          value={returnHorizons}
          setValue={(val) => setReturnHorizons(val)}
          multiple
          context={context}
        />
      </mui.core.Box>
      <mui.core.Box mt={5}>
        <ui.WidgetHistories<true>
          multiple
          value={selectedHistories}
          setValue={setSelectedHistories}
          context={context}
        />
      </mui.core.Box>
      <mui.core.Box mt={2}>
        <mui.core.FormControlLabel
          control={
            <mui.core.Switch size="small" checked={withBenchmark} onChange={() => setWithBenchmark(!withBenchmark)} />
          }
          label="Has benchmark"
        />
      </mui.core.Box>

      {withBenchmark && (
        <mui.core.Box mt={2}>
          <ui.Benchmark
            value={benchmark || undefined}
            setValue={setBenchmark}
            universeContextPath={'$universe.handle'}
            hiddenOptions={[ts.enums.BENCHMARK_TYPES_ENUM.DS_INDEX]}
            universeIdPath="universe_id"
          />
        </mui.core.Box>
      )}

      {isAlpha && (
        <mui.core.Box mt={2}>
          <mui.core.FormControlLabel
            control={
              <mui.core.Switch
                size="small"
                checked={showResidualsAlpha}
                onChange={() => setShowResidualsAlpha(!showResidualsAlpha)}
              />
            }
            label="Show residuals alpha"
          />
        </mui.core.Box>
      )}
    </mui.core.Box>
  );
};

export default Form;
